import { render, staticRenderFns } from "./EditCommunityPage.vue?vue&type=template&id=384b12fa&"
import script from "./EditCommunityPage.vue?vue&type=script&lang=js&"
export * from "./EditCommunityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports